export class Referral {
    referralId: string
    label: string
    createdAt: Date
}
